import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useLocale } from '../contexts/LocaleContext'

/**
 * The closing call to action. The address typed here is carried into the signup form
 * so nobody has to type it twice.
 */
const SignupBand: React.FC = () => {
  const { t } = useLocale()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')

  const start = (e: React.FormEvent) => {
    e.preventDefault()
    navigate(email.trim() ? `/signup?email=${encodeURIComponent(email.trim())}` : '/signup')
  }

  return (
    <section id="signup" className="bg-clay-500 px-5 py-16 sm:px-8 lg:px-14 lg:py-[72px]">
      <div className="mx-auto max-w-[880px] text-center">
        <h2 className="font-display text-[30px] font-bold tracking-display text-neutral-50 sm:text-[38px]">
          {t('signup.bandTitle')}
        </h2>
        <p className="mt-3.5 text-[17px] text-peach-300">{t('signup.bandSubtitle')}</p>

        <form onSubmit={start} className="mt-7 flex flex-wrap justify-center gap-2.5">
          <label className="sr-only" htmlFor="band-email">
            {t('signup.email')}
          </label>
          <input
            id="band-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t('signup.emailPlaceholder')}
            className="min-h-touch-comfort w-full max-w-[320px] rounded-md bg-white px-[18px] text-base text-text-primary placeholder:text-text-muted"
          />
          <button
            type="submit"
            className="inline-flex min-h-touch-comfort items-center rounded-md bg-neutral-900 px-7 text-[17px] font-semibold text-neutral-50 hover:bg-neutral-800"
          >
            {t('navigation.startFreeTrial')}
          </button>
        </form>
      </div>
    </section>
  )
}

export default SignupBand
